import React from 'react'
import '../App.css'


function Header() {

    const menu = [
        { name: 'Home', href: '#home' },
        { name: 'About', href: '#about' },
        { name: 'Skills', href: '#skills' },
        { name: 'Projects', href: '#projects' },
        { name: 'Blogs', href: '#blogs' },
        { name: 'Contact', href: '#contact' },
    ]

    return (
        <div className="navbar bg-[#242526] h-16 lg:h-20 md:h-20 sticky top-0 z-10">
            <div className="navbar-start w-full">
                <div className="dropdown">
                    <label tabIndex="0" className="btn btn-primary btn-sm ml-2 mr-0 lg:hidden md:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex="0" className="menu menu-compact text-white dropdown-content mt-3 p-2 shadow bg-[#242526]  rounded-box text-lg w-52">
                        {menu?.map(m => (
                            <li data-aos="fade-down" data-aos-delay="800" data-aos-duration="1000" data-aos-offset="300" data-aos-easing="ease-in-sine" ><a className=' hover:text-[#17A875] py-2 px-4 border-0 rounded-none' href={m?.href}>{m?.name}</a></li>
                        ))}
                    </ul>
                </div>
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <p className=" lg:ml-28 md:ml-20 ml-5 hover:text-[#17A875] text-white text-2xl lg:text-4xl font-bold tracking-wide">Faijul Azim</p>
                </div>
            </div>
            <div className="navbar-center hidden lg:flex md:flex">
                <ul className="menu menu-horizontal text-white text-lg p-0 mr-28">
                    {menu?.map(m => (
                        <li data-aos="fade-down" data-aos-delay="800" data-aos-duration="1000" data-aos-offset="300" data-aos-easing="ease-in-sine" ><a className=' hover:text-[#17A875] py-2 px-5 border-0  rounded-none' href={m?.href}>{m?.name}</a></li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default Header;
